import { render } from "./CreateNewTaskPage.vue?vue&type=template&id=5197b507&ts=true"
import script from "./CreateNewTaskPage.vue?vue&type=script&lang=ts"
export * from "./CreateNewTaskPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__